import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { meta } from '../../../meta';

export const EmptyCategory = () => {
  const { t } = useTranslation();

  return (
    <Text>
      {t(
        'Sorry, but there are no photos to display in this category at the moment.'
      )}
    </Text>
  );
};

const Text = styled.p.attrs({
  className: `${meta.stylePrefix}-empty-category-text`
})`
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: #111111;
  text-align: center;
  padding-top: 40px;
`;
